import { Grid } from "@mui/material";
import servicios from "../../../../Data/soluciones.json";
import Tarjeta_Enfoque_Servicios from "../../Tarjetas/Tarjeta_Enfoque_Servicios";
import { useResponsive } from "../../../../Modulo_Responsive/Hooks/useResponsive";

const Lista_Enfoque_Servicios = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            size={{ xs: 12 }}
            spacing={sCell ? 4 : 8}
        >
            {servicios.map((item, index) => (
                <Grid key={index} size={{ xs: 12, sm: 6, md: 6 }}>
                    <Tarjeta_Enfoque_Servicios
                        titulo={item.titulo}
                        descripcion={item.descripcion}
                        servicios={item.servicios}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default Lista_Enfoque_Servicios;